import BreakfastImage from '../../images/meal-icon/breakfast.svg';
import DinnerImage from '../../images/meal-icon/dinner.svg';
import LateLunchImage from '../../images/meal-icon/latelunch.svg';
import { Link } from 'react-router-dom';
import LunchImage from '../../images/meal-icon/lunch.svg';
import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

function getIcon(name, focus) {
  switch (name) {
    case "Breakfast": return <img src={BreakfastImage} alt="Meal Icon" className={focus ? 'meal-icon-highlight' : 'meal-icon'} />;
    case "Lunch": return <img src={LunchImage} alt="Meal Icon" className={focus ? 'meal-icon-highlight' : 'meal-icon'} />;
    case "Dinner": return <img src={DinnerImage} alt="Meal Icon" className={focus ? 'meal-icon-highlight' : 'meal-icon'} />;
    default: return <img src={LateLunchImage} alt="Meal Icon" className={focus ? 'meal-icon-highlight' : 'meal-icon'} />;  // other current types include "Snack" and "Unknown"
  }
}

const MealPickerMeal = (props) => {
  const { locationName, selectedDate, alt, hideName, name, link, selectMeal } = props;
  
  let LocationDateLink = "/" + locationName + moment(selectedDate).format('/YYYY/M/D/');
  let className = classNames(
    "mealpicker-meal",
    "mealpicker-meal" + (alt ? "--alt" : '')
  );
  let mealName = hideName ? null : <span className="mealpicker-meal-name">{name}</span>;
  return link ?
    <Link to={LocationDateLink + name} key={name} onClick={() => selectMeal(name)}>{<Meal className={className} mealName={mealName} focus={false} {...props} />}</Link>
    :
    <Meal className={className} mealName={mealName} name={name} focus={true} {...props} />;
}

const Meal = (props) => {
  const { status, className, mealName, name, focus } = props;
  
  function formatTime(time) {
    let output = "";
    let timeFormat = "h:mma";
    let altTimeFormat = "ha";
    //Time should already be moment object
    if (time.format("mm") === "00") {
      output = time.format(altTimeFormat);
    }
    else {
      output = time.format(timeFormat);
    }
    return output;
  }

  function formatDateTime(meal) {
    let StartTime = moment.parseZone(meal.startTime);
    let EndTime = moment.parseZone(meal.endTime);
    if (meal.startTime && meal.endTime) {
      return formatTime(StartTime) + " – " + formatTime(EndTime);
    }
    return "Closed";
  }

  return (
    <div className={className}>
      <span className="mealpicker-meal-icon">{getIcon(name, focus)}</span>
      <div className="mealpicker-meal-details">
        {mealName}
        <span className="mealpicker-meal-times">{status !== "CLOSED" ? formatDateTime(props) : <span className="meal-status-closed">Closed</span>}</span>
      </div>
    </div>
  )
}

export default MealPickerMeal;